<template>
    <div>
      <Header></Header>
      <Navbar></Navbar>
      <Main></Main>
    </div>
</template>
<script>
import Header from './layout/Header.vue'
import Navbar from './layout/Navbar.vue'
import Main from './layout/Main.vue'

export default {
  name:"HomeView",
  components: { Header, Main, Navbar },
  data(){
    return {

    }
  },
  created(){

  },
  methods: {

  }
}
</script>

<style scoped lang="less">

  /*下拉框样式*/
  .el-dropdown-link {
      cursor: pointer;
      color: #409EFF;
  }
  .el-icon-arrow-down {
      font-size: 12px;
  }
  /*后期header样式*/
  .el-header{
      /*流式布局*/
      display: flex;
      justify-content: space-between;
  }

  /* 头部样式 */
  .header {
    position: absolute;
    line-height: 50px;
    top: 0px;
    left: 0px;
    right: 0px;
    z-index: 9;
    background-color: #2d3a4b;
  }

  /* 左侧样式 */
  .navbar {
    position: absolute;
    width: 200px;
    top: 50px;
    left: 0px;
    bottom: 0px;
    overflow-y: auto; /* 当内容过多时y轴出现滚动条 */
    background-color: rgb(51, 55, 68);
  }

  /*整体框架样式*/
  .el-header, .el-footer {
      background-color: #B3C0D1;
      color: #333;
      text-align: center;
      line-height: 50px;
  }

  .el-aside {
      color: #333;
      text-align: center;
      background-color: rgb(51, 55, 68);
  }
  /deep/.el-aside{
    overflow: hidden;
  }
  .el-main {
      background-color: #E9EEF3;
      color: #333;
      text-align: center;
      line-height: 160px;
  }
  body > .el-container {
      margin-bottom: 40px;
  }
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
      line-height: 260px;
  }
  .el-container:nth-child(7) .el-aside {
      line-height: 320px;
  }
  .el-menu{
    background-color: transparent;
  }

</style>

